import React, { useState,useEffect } from "react";
import "./Optimizer.css";
import hdIcon from "../../../images/img/hd-icon.svg";
import sdIcon from "../../../images/img/sd-icon.svg";
import thumbIcon from "../../../images/img/thumb-icon.svg";
import addIcon from "../../../images/img/add-icons.svg";
import rightIcon from "../../../images/icons/right-icons.svg";
export default function OptimizerComponent(props) {
  console.log(props, "props");
  const { yourSelection, bestFitPack } = props.data;

  const {filterToggle,onClickSubmit,code,tag} = props
  const [yourSelectionData, setYourSelectionData] = useState(yourSelection);
  const [bestFitPackData, setBestFitPackData] = useState(bestFitPack);
  const [refresh,setRefresh] = useState(false)
  const [dataToBeSent,setDataToBeSent] = useState({})
//useEffects
useEffect(()=>{
  yourSelectionData.checked=false
 
},[])
useEffect(()=>{
  bestFitPackData.checked=false
 
},[])
  const selectYourSelection = () => {
      setRefresh(!refresh)
    if (yourSelectionData.checked === false) {

      const tempSelection=yourSelection;
      tempSelection.checked = true;
      bestFitPack.checked = false;
      setYourSelectionData(tempSelection);
      setDataToBeSent({key1:"Selected"})
      console.log(yourSelectionData);
    } else {
        const tempSelection=yourSelection;
        tempSelection.checked = false;
      setYourSelectionData(tempSelection);
      console.log(yourSelectionData);
    }
    setRefresh(!refresh)
  };
  const selectBestFitPack = () => {
    setRefresh(!refresh)
    if (bestFitPackData.checked === false) {
        const tempBestPack =bestFitPack;
        tempBestPack.checked = true;
      yourSelection.checked = false;
      setBestFitPackData(tempBestPack);
      console.log(bestFitPackData);
      setDataToBeSent({key1:"Optimized"})
    } else {
        const tempBestPack =bestFitPack;
        tempBestPack.checked = false;
      setBestFitPackData(tempBestPack);
      console.log(bestFitPackData);
    }
    setRefresh(!refresh)
  };

  const handleSubmit =()=>{
      console.log(code,dataToBeSent,tag,"in optimizer component")
      onClickSubmit(code,dataToBeSent,tag);
      if(dataToBeSent.key1==="Selected"){
          localStorage.setItem("selectedOptimizer",JSON.stringify({optimizer:"Selected"}));
          
        }
        else{
          localStorage.setItem("selectedOptimizer",JSON.stringify({optimizer:"BestFit"}));
      }
    filterToggle(true)
    }
  return (
    <div className="optimizerComponenetContainer">
        
      {yourSelection !== undefined ?<div
        className="yourSelectionBox"
        onClick={() => selectYourSelection()}
        style={{
          border:
            yourSelectionData.checked === true
              ? "1px solid #E10092 "
              : "1px solid rgba(206,210,218,0.6)",
        }}
      >
        <div className="boxSelection-header">
          <div className="boxSelection-header-radioContainer">
            <input
              type="radio"
              name="yourSelection"
              value="1"
              checked={yourSelectionData.checked}
            />
            <p>Your Selection</p>
          </div>
          <div className="boxselection-priceContainer-yourPack">
            <p>{yourSelectionData.price}</p>
          </div>
        </div>
        <div className="boxselection-hdsdContainer">
        <span></span>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={hdIcon} /> <p>{yourSelectionData.noOfHdChannels}</p>
           
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={sdIcon} /> <p>{yourSelectionData.noOfSdChannels}</p>
          </div>
          <span></span>
        </div>
        <div className="optimizer-description-container">
          <img src={thumbIcon} width="15px" height="15px" />
          <p>{yourSelectionData.description}</p>
        </div>
        <div className="optimizer-channelList">
          <p>View Channels List</p>
          <img src={rightIcon} width="15px" height="15px" />
        </div>
      </div> : null}
      <div
        className="bestFiltBox"
        onClick={() => selectBestFitPack()}
        style={{
          border:
            bestFitPackData.checked === true
              ? "1px solid #E10092 "
              : "1px solid rgba(206,210,218,0.6)",
        }}
      >
        
        <div class="offer-tag-div">Offer for you</div>  
        <div className="boxSelection-header">
          <div className="boxSelection-header-radioContainer">
         
            <input
              type="radio"
              name="yourSelection"
              value="1"
              checked={bestFitPackData.checked}
              style={{cursor:'pointer'}}  
            />
            <p>Best Fit Pack</p>
          </div>
          <div className="boxselection-priceContainer">
            <p>{bestFitPackData.price}</p>
            <p>You Save {bestFitPackData.benefitPrice}</p>
          </div>
        </div>
        <div className="boxselection-hdsdContainer">
        <span></span>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={hdIcon} /> <p>{bestFitPackData.noOfHdChannels}</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={sdIcon} /> <p>{bestFitPackData.noOfSdChannels}</p>
          </div>
          <span></span>
        </div>

        <div className="optimizer-description-container">
          <img src={thumbIcon} width="15px" height="15px" />
          <p>{bestFitPackData.description}</p>
        </div>
        <div className="optimizer-description-container">
          <img src={addIcon} width="15px" height="15px" />
          <p>{bestFitPackData.benefitDescription}</p>
        </div>
        <div className="optimizer-channelList">
          <p>View Channels List</p>
          <img src={rightIcon} width="15px" height="15px" />
        </div>
      </div>
      <div className="BoxSelection-button waves-effect waves-light">
        <button onClick={()=> handleSubmit(dataToBeSent)}>Confirm Pack</button>
      </div>
    </div>
  );
}
